// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/ImageUploader.js

import React from 'react';

const ImageUploader = ({ 
  mode, 
  selectedImage, setSelectedImage, 
  previewImage, setPreviewImage, 
  translations, memberData 
}) => {
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        setPreviewImage(fileReader.result);
      };
    }
  };

  if (mode !== 'edit') return null;

  return (
    <div className="mb-3">
      <label htmlFor="imageInput" className="form-label">{translations.photoLabel || "Photo"}</label>
      <input
        type="file"
        className="form-control"
        id="imageInput"
        onChange={handleImageChange}
      />
      {previewImage && (
        <img
          src={previewImage}
          alt="Preview"
          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
        />
      )}
    </div>
  );
};

export default ImageUploader;